import React from "react";
import { Link } from "react-router-dom";
import T from "prop-types";

export const PrimaryButton = ({ text, className, onClick }) => (
  <Link to={onClick}>
    <button className={className}>
      <span>{text}</span>
    </button>
  </Link>
);

PrimaryButton.T = {
  onClick: T.func,
  className: T.string,
  text: T.string,
};

PrimaryButton.defaultProps = {
  onClick: null,
  className: "primaryButtonCls",
  text: "",
};
